import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in zh-cn.webinars.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/zh-cn/webinars")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
